import { ButtonVariants } from '@anm/components/buttons/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { FC } from 'react';

import Wrapper, { Description, Title } from './Wrapper';

export type TeamActionBlockProps = {
  title: string;
  description: string;
  actionName: string;
  onClick: () => void;
  isPending?: boolean;
  buttonVariant?: ButtonVariants;
};

const TeamActionBlock: FC<TeamActionBlockProps> = ({
  title,
  description,
  actionName,
  isPending,
  buttonVariant = 'bordered-red',
  onClick
}) => {
  return (
    <>
      <Wrapper>
        <div>
          <Title>{title}</Title>
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        </div>
        <ButtonLoader size="large" variant={buttonVariant} isPending={isPending} onClick={onClick}>
          {actionName}
        </ButtonLoader>
      </Wrapper>
    </>
  );
};
export default TeamActionBlock;
